<div class="hit" *ngIf="melody" [class.playing]="melody.isPlaying">
  <div class="hit__cover">
    <div class="hit__img" (click)="purchaseMelody()">
      <img [src]="melody.pictureUrl" [alt]="melody.title + ',' + melody.artistTitle" appReplaceMissingImage/>
    </div>
    <div class="hit__controls">
      <div class="hit__control" (click)="toggleFavorite()">
        <div class="icon" [class.icon-star]="!melody.favorite" [class.icon-star-filled]="melody.favorite"></div>
      </div>
      <div class="hit__control-player">
        <div class="player player_size_big" (click)="play()">
          <div class="player__button" [class.icon-play]="!melody.isPlaying" [class.icon-pause]="melody.isPlaying"></div>
          <div class="player__progressbar" #progressBar></div>
        </div>
      </div>
      <div class="hit__control" (click)="giftMelody()" [class.disabled]="!showGiftButton">
        <div class="icon icon-gift"></div>
      </div>
    </div>
  </div>
  <div class="hit__content">
    <div class="hit__title">
      <a [routerLink]="'/melodies/' + melody.melodyMarketplaceId" class="hit__title-link">{{melody.title}}</a>
    </div>
    <div class="hit__subtitle">
      <a [routerLink]="'/artists/' + melody.artistId" class="hit__subtitle-link">{{melody.artistTitle}}</a>
    </div>
    <div class="hit__button">
      <div class="button button_type_light" [class.button_status_disabled]="purchased" (click)="purchaseMelody()">
        <ng-container *ngIf="purchased; else purchaseTemplate">
          {{ 'hit-melodies.already-installed' | translate }}
        </ng-container>
        <ng-template #purchaseTemplate>
          {{ 'hit-melodies.purchase' | translate }}
        </ng-template>
      </div>
    </div>
  </div>
</div>
